import {
  MONITOR_SUPPLIER_LOAD,
  MONITOR_SUPPLIER_LOAD_SUCCESS,
  MONITOR_SUPPLIER_ERROR,
  MONITOR_SUPPLIER_CLEAN
} from "./actionTypes"

export const monitorsupplierError = error => {
  return {
    type: MONITOR_SUPPLIER_ERROR,
    payload: error,
  }
}
export const initLoadSuppliers= (filter) => {
  return {
    type: MONITOR_SUPPLIER_LOAD,
    payload: filter,
  }
}

export const loadSuppliers= orders => {
  orders.forEach(c => {
    c.label = c.name
    c.value = c.code
  })
  return {
    type: MONITOR_SUPPLIER_LOAD_SUCCESS,
    payload: orders,
  }
}

export const cleanSuppliers = () => {
  return {
    type: MONITOR_SUPPLIER_CLEAN,
    payload: {},
  }
}
